// ARQUIVO GERADO AUTOMATICAMENTE POR ASSETS_FIXER.PY
// CONTÉM AS LOGOS EM BASE64 PARA EVITAR FLICKER DE REDE

const BUCKET = "portalrda-f312d.firebasestorage.app";
const BASE_URL = `https://firebasestorage.googleapis.com/v0/b/${BUCKET}/o/Public%2F`;
const SUFFIX = "?alt=media";

export const LOCAL_ASSETS = {
  logoIcon: `${BASE_URL}Logo%20RDA%20-%20APENAS%20LOGO%20BRANCA.svg${SUFFIX}`,
  logoName: `${BASE_URL}Logo%20RDA%20-%20APENAS%20NOME%20BRANCO.svg${SUFFIX}`,
  logoBlue: `${BASE_URL}Logo%20RDA%20-%20AZUL.png${SUFFIX}`,
  profile: `${BASE_URL}profile.jpg${SUFFIX}`,
  dogs: `${BASE_URL}dogs.jpg${SUFFIX}`,
  office: `${BASE_URL}office.jpg${SUFFIX}`,
  bannerHero: `${BASE_URL}Banner%20Hero.jpg${SUFFIX}`,
  placeholders: {
    user: "https://ui-avatars.com/api/?name=RDA&background=20243B&color=fff",
    cover: "https://placehold.co/600x400/20243B/FFFFFF?text=Imagem+Indisponivel"
  }
};